import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  apiBaseUrl : string = environment.url;
    checkedCategoryList:any;
    isSelectedAll:boolean = false
  constructor(private _http:HttpClient) { }

   getBulkSms(page:number, limit:number, search:string=""){
    return this._http.get(`${this.apiBaseUrl}v1/get-bulkSms?page=${page}&limit=${limit}&search=${search}`);
 }
 
 getSmsWithoutPagination(search:string=""){
   return this._http.get(`${this.apiBaseUrl}v1/view-all-users?search=${search}`);
 }
 SendSms(data:any){
   return this._http.post(`${this.apiBaseUrl}v1/sms`, data);
  }
  getAllSentSms(){
  return this._http.get(this.apiBaseUrl+'v1/get-sms');
  }
  getUsersSentEmails(user_id){
    return this._http.get(this.apiBaseUrl+'v1/get-massEmails?user='+user_id);
  }
  deleteSms(ids:string[]){
    const paramValue = ids.join(',');
  return this._http.delete(`${this.apiBaseUrl}v1/delete-sms`, { params : {ids :paramValue} } );
}

}





 



